import { Controller } from "stimulus"


export default class extends Controller {
  static targets = ['active']

  connect() {
  }

  activate(e) {
    if (!$(e.target).hasClass('active')) {
      $(this.activeTarget).removeClass('active')
      $(e.target).addClass('active')
    }
  }

  deactivate(e) {
    if (!$(this.activeTarget).hasClass('active')) {
      $(e.target).removeClass('active')
      $(this.activeTarget).addClass('active')
    }
  }
}